const adColors = {
	white: '#fff',
	black: '#161537',
	blue: '#1b55e3',
	yellow: '#ff0',
	orange: '#ff8200',
	red: '#f2135d',
	pink: '#fd3995',
	purple: '#5b3cc4',
	'blue-light': '#3d6ee7',
	'gray-1': '#f2f4f8',
	'gray-2': '#e4e9f0',
	'gray-3': '#dde2ec',
	'gray-4': '#c3bedc',
	'gray-5': '#aca6cc',
	'gray-6': '#786fa4',
	'dark-gray-1': '#aeaee0',
	'dark-gray-2': '#7575a3',
	'dark-gray-3': '#4f4f7a',
	'dark-gray-4': '#2a274d',
	'dark-gray-5': '#161537',
	'dark-gray-6': '#100f28'
};

const bsColors = {
	default: adColors['gray-4'],
	primary: adColors.blue,
	secondary: '#6a7a84',
	success: '#17c964',
	info: adColors.blue,
	warning: adColors.orange,
	danger: adColors.red,
	light: adColors['gray-1'],
	dark: adColors.black
};

const colors = { ...adColors, ...bsColors };

module.exports = {
	colors,
	theme: {
		'@body-background': '#fff',
		// '@font-size-base': '15px',
		// '@font-size-sm': '13px',
		// '@font-size-lg': '17px',

		'@font-family': 'Montserrat, sans-serif',
		'@code-family': 'Montserrat, sans-serif',

		'@border-color-base': '#e4e9f0',

		'@background-color-light': '#f2f4f8',
		'@background-color-base': '#f2f4f8',

		'@primary-color': '#1b55e3',
		'@info-color': '#0887c9',
		'@success-color': '#46be8a',
		'@error-color': '#fb434a',
		'@highlight-color': '#fb434a',
		'@warning-color': '#f39834',
		'@normal-color': '#e4e9f0',

		'@input-color': '#161537',
		// '@input-padding-horizontal': '13px',
		// '@input-padding-vertical-base': '7px',
		// '@input-padding-vertical-sm': '11px',
		// '@input-padding-vertical-lg': '11px',
		'@input-border-color': '#e4e9f0',
		'@input-hover-border-color': '#0190fe',

		'@shadow-color': 'rgba(0,0,0,.15)',
		'@box-shadow-base': '0 10px 35px -5px rgba(0,0,0,.15)',
		'@shadow-1-up': '0 -10px 35px -5px rgba(0,0,0,.15)',
		'@shadow-1-down': '0 10px 35px -5px rgba(0,0,0,.15)',
		'@shadow-1-left': '-10px 10px 35px -5px rgba(0,0,0,.15)',
		'@shadow-1-right': '10px 0 35px -5px rgba(0,0,0,.15)',
		'@shadow-2': '0 0px 35px -5px rgba(0,0,0,.15)',

		'@table-header-bg': '#f2f4f8',
		'@table-header-sort-bg': '#f2f4f8',
		'@table-row-hover-bg': '#e4e9f0',
		'@table-padding-vertical': '12px',
		'@table-padding-horizontal': '8px',

		'@modal-mask-bg': 'rgba(15, 12, 41, 0.5)',

		'@layout-body-background': '#fff',
		'@layout-header-background': 'transparent',
		'@layout-sider-background': 'transparent',

		'@animation-duration-slow': '0.3s', // Modal
		'@animation-duration-base': '0.2s',
		'@animation-duration-fast': '0.1s' // Tooltip
	}
};
